import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=f42f7ba2&scoped=true&"
import script from "./AddAdmin.vue?vue&type=script&lang=js&"
export * from "./AddAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=f42f7ba2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42f7ba2",
  null
  
)

export default component.exports